import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminReducersPage } from '../../../../components/pages/backoffice/platform/platform-admin-reducers-page/platform-admin-reducers-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/reducers/')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PlatformAdminReducersPage />
    </PermissionChecker>
  ),
})
